import React from 'react'
import {
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Button } from '@one-thd/sui-atomic-components';
import { string } from 'prop-types';

const ViewDetailsLink = ({ itemId, trackingParam }) => {
  const { data, error, loading } = useDataModel('product',
    {
      variables: {
        itemId
      }
    }
  );

  if ((loading && !data) || error) {
    return null;
  }

  let { canonicalUrl } = data?.product?.identifiers || {};

  const productLink = canonicalUrl + trackingParam;

  return (
    <Button variant="primary" href={productLink} fullWidth>
      View Full Product Details
    </Button>
  )
}

ViewDetailsLink.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    itemId: stringType(),
    identifiers: shapeType({
      canonicalUrl: stringType(),
    }),
  }),
};

ViewDetailsLink.propTypes = {
  itemId: string.isRequired,
  trackingParam: string,
};

ViewDetailsLink.defaultProps = {
  trackingParam: ''
}

export default ViewDetailsLink;